import { cn } from "@/lib/utils";

const Notification = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cn("size-6", className)}
  >
    <path
      d="M13.4534 18C13.4534 19.6569 12.1102 21 10.4534 21C8.79652 21 7.45337 19.6569 7.45337 18M12.2499 5.23856C12.6854 4.78864 12.9534 4.17562 12.9534 3.5C12.9534 2.11929 11.8341 1 10.4534 1C9.07266 1 7.95337 2.11929 7.95337 3.5C7.95337 4.17562 8.22138 4.78864 8.65687 5.23856M1.00019 7.32296C0.985847 5.87161 1.76833 4.51631 3.03241 3.80306M19.9066 7.32296C19.9209 5.87161 19.1384 4.51631 17.8743 3.80306M16.4534 10.2C16.4534 8.82087 15.8212 7.49823 14.696 6.52304C13.5708 5.54786 12.0447 5 10.4534 5C8.86207 5 7.33595 5.54786 6.21073 6.52304C5.08552 7.49823 4.45337 8.82087 4.45337 10.2C4.45337 12.4818 3.8875 14.1506 3.18144 15.3447C2.37671 16.7056 1.97435 17.3861 1.99024 17.5486C2.00842 17.7346 2.04189 17.7933 2.19271 17.9036C2.32454 18 2.98688 18 4.31156 18H16.5952C17.9199 18 18.5822 18 18.714 17.9036C18.8649 17.7933 18.8983 17.7346 18.9165 17.5486C18.9324 17.3861 18.53 16.7056 17.7253 15.3447C17.0192 14.1506 16.4534 12.4818 16.4534 10.2Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Notification;
